import { createFileRoute } from "@tanstack/react-router";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";
import { supabase } from "@/integrations/supabase/client";
import { runSchedulerNow } from "@/lib/scheduler.functions";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Play, Clock } from "lucide-react";

export const Route = createFileRoute("/_authenticated/scheduler")({ component: Page });

function Page() {
  const qc = useQueryClient();
  const run = useServerFn(runSchedulerNow);
  const { data: settings } = useQuery({
    queryKey: ["scheduler-settings"],
    queryFn: async () => {
      const { data } = await supabase.from("app_settings").select("*").in("key", ["scheduler_interval_hours", "last_scheduler_run_at"]);
      const map: any = {}; (data ?? []).forEach((r: any) => map[r.key] = r.value); return map;
    },
  });
  const setInterval = async (h: number) => {
    const { error } = await supabase.from("app_settings").upsert({ key: "scheduler_interval_hours", value: h as any }, { onConflict: "key" } as any);
    if (error) return toast.error(error.message);
    toast.success(`ตั้งรอบเป็นทุก ${h} ชั่วโมง`);
    qc.invalidateQueries({ queryKey: ["scheduler-settings"] });
  };
  const doRun = async () => {
    try { toast.loading("กำลังรัน scheduler...", { id: "rs" }); const r: any = await run({}); toast.success(`เสร็จ — sources:${r.sourcesRun} ins:${r.inserted} tr:${r.translated} sent:${r.sent}`, { id: "rs", duration: 5000 }); qc.invalidateQueries({ queryKey: ["scheduler-settings"] }); }
    catch (e: any) { toast.error(e.message, { id: "rs" }); }
  };
  const interval = Number(settings?.scheduler_interval_hours ?? 1);
  const lastRun = settings?.last_scheduler_run_at;

  return (
    <div className="space-y-6">
      <div><h1 className="text-2xl font-display font-semibold">Scheduler</h1><p className="text-sm text-muted-foreground">ตั้งรอบดึงข่าว แปล และส่งอัตโนมัติ</p></div>
      <div className="grid gap-4 md:grid-cols-2">
        <Card>
          <CardHeader><CardTitle className="flex items-center gap-2"><Clock className="h-4 w-4 text-primary"/>รอบการรัน</CardTitle><CardDescription>เลือกความถี่ที่ระบบจะดึง+แปล+ส่งข่าวอัตโนมัติ</CardDescription></CardHeader>
          <CardContent className="space-y-3">
            <Label>ทุก ๆ</Label>
            <Select value={String(interval)} onValueChange={(v) => setInterval(Number(v))}>
              <SelectTrigger><SelectValue/></SelectTrigger>
              <SelectContent>
                <SelectItem value="1">ทุก 1 ชั่วโมง</SelectItem>
                <SelectItem value="2">ทุก 2 ชั่วโมง</SelectItem>
                <SelectItem value="3">ทุก 3 ชั่วโมง</SelectItem>
                <SelectItem value="6">ทุก 6 ชั่วโมง</SelectItem>
              </SelectContent>
            </Select>
            <div className="text-xs text-muted-foreground">รันล่าสุด: {lastRun ? new Date(lastRun).toLocaleString("th-TH") : "—"}</div>
          </CardContent>
        </Card>
        <Card>
          <CardHeader><CardTitle>Run Now</CardTitle><CardDescription>รัน scheduler ทันทีโดยไม่รอรอบ</CardDescription></CardHeader>
          <CardContent><Button onClick={doRun} className="w-full"><Play className="h-4 w-4 mr-2"/>เริ่มรัน Scheduler</Button></CardContent>
        </Card>
      </div>
    </div>
  );
}